var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.75,
    height: 33,
    viewBox: "0 0 24.75 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#525252;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.656,12.375H20.625V8.25a8.25,8.25,0,0,0-16.5,0v4.125H3.094A3.1,3.1,0,0,0,0,15.469V29.906A3.1,3.1,0,0,0,3.094,33H21.656a3.1,3.1,0,0,0,3.094-3.094V15.469A3.1,3.1,0,0,0,21.656,12.375ZM6.875,8.25a5.5,5.5,0,0,1,11,0v4.125h-11Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.07b1ab95.svg";
export { ForwardRef as ReactComponent };